import * as React from "react";
import { hasAnyExceleRATEProduct, hasDriveABLEProduct } from "./ProductType";
import { Tooltip } from "antd";

export const inOfficeScoreToolTip = (productType?: ProductType) => {
	if (hasAnyExceleRATEProduct(productType)) {
		return <Tooltip title="Vitals">VITALS</Tooltip>;
	} else if (hasDriveABLEProduct(productType)) {
		return <Tooltip title="DCAT">DCAT</Tooltip>;
	}

	return null;
};

export const overallScoreToolTip = (productType?: ProductType) => {
	if (hasAnyExceleRATEProduct(productType)) {
		return <Tooltip title="ExceleRATE">ExceleRATE</Tooltip>;
	} else if (hasDriveABLEProduct(productType)) {
		return <Tooltip title="DriveABLE">DriveABLE</Tooltip>;
	}

	return null;
};

export const inofficeRecommendationToolTip = (productType?: ProductType) => {
	if (hasAnyExceleRATEProduct(productType)) {
		return (
			<Tooltip title="Vitals Recommendation">VITALS RECOMMENDATION</Tooltip>
		);
	} else if (hasDriveABLEProduct(productType)) {
		return <Tooltip title="DCAT Recommendation">DCAT RECOMMENDATION</Tooltip>;
	}

	return null;
};

export const onroadScoreToolTip = (productType?: ProductType) => {
	if (hasAnyExceleRATEProduct(productType)) {
		return <Tooltip title="CORE">CORE</Tooltip>;
	} else if (hasDriveABLEProduct(productType)) {
		return <Tooltip title="DORE">DORE</Tooltip>;
	}

	return null;
};
